function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "calendar");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar",
  transform: "translate(0.000000, 0.050000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,2.5 L13.75,2.5 L13.75,0.589843988 C13.75,0.279804468 13.4687495,0 13.125,0 C12.7812505,0 12.5,0.279804468 12.5,0.589843988 L12.5,2.5 L5,2.5 L5,0.589843988 C5,0.279804468 4.71875012,0 4.375,0 C4.03124988,0 3.75,0.279804468 3.75,0.589843988 L3.75,2.5 L2.5,2.5 C1.11914039,2.5 0,3.61914039 0,5 L0,17.5 C0,18.8808596 1.11914039,20 2.5,20 L15,20 C16.3808596,20 17.5,18.8808596 17.5,17.5 L17.5,5 C17.5,3.61914039 16.3789058,2.5 15,2.5 Z M2.5,3.75 L15,3.75 C15.6902349,3.75 16.25,4.30976629 16.25,5 L16.25,6.25 L1.25,6.25 L1.25,5 C1.25,4.30859327 1.8097657,3.75 2.5,3.75 Z M15,18.75 L2.5,18.75 C1.8097657,18.75 1.25,18.1902349 1.25,17.5 L1.25,7.5 L16.25,7.5 L16.25,17.5 C16.25,18.1914067 15.6914067,18.75 15,18.75 Z",
  id: "Shape"
})));
const SvgIconCalendar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-calendar.2c1b052a.svg";
export { ForwardRef as ReactComponent };